import { computed as s, defineComponent as U, h as R, ref as f, watchEffect as Se, onBeforeMount as Ve, onBeforeUpdate as Le, watch as I, onMounted as Pe, nextTick as x, resolveComponent as Oe, openBlock as w, createElementBlock as J, normalizeClass as we, createBlock as G, resolveDynamicComponent as B, mergeProps as Q, createSlots as X, withCtx as P, renderSlot as z, toDisplayString as N, createVNode as ze, normalizeProps as T, guardReactiveProps as E, createCommentVNode as Fe, createElementVNode as Y, renderList as Z } from "vue";
import { getSupportedRegionCodes as Me, getExample as ke, parsePhoneNumber as _e } from "awesome-phonenumber";
import { allCountries as Ae } from "country-telephone-data";
import { VListItem as Ge, VSelect as Be, VTextField as K } from "vuetify/components";
function ne() {
  return {
    country: {
      required: !0,
      type: Object
    },
    decorative: {
      required: !0,
      type: Boolean
    }
  };
}
function te({ props: e }) {
  const n = s(() => e.decorative ? void 0 : "img"), t = s(() => e.decorative ? void 0 : e.country.name);
  return { role: n, title: t };
}
const $e = U({
  props: ne(),
  setup(e) {
    const { role: n, title: t } = te({ props: e });
    return () => R("span", {
      role: n.value,
      title: t.value,
      class: ["v-phone-input__country__icon", "f32"]
    }, R("span", { class: ["flag", e.country.iso2.toLowerCase()] }));
  }
}), je = U({
  props: ne(),
  setup(e) {
    const { role: n, title: t } = te({ props: e });
    return () => R("span", {
      role: n.value,
      title: t.value,
      class: [
        "v-phone-input__country__icon",
        "fi",
        `fi-${e.country.iso2.toLowerCase()}`
      ]
    });
  }
});
function Ne(e) {
  return "setPreference" in e;
}
function F(e) {
  return e && typeof e == "object" ? e.iso2 : (e || "").toUpperCase();
}
function Te({ props: e }) {
  const n = Me(), t = f({}), r = f(0), i = f([]), p = f([]), v = s(() => e.preferCountries.map(F)), o = s(() => e.includeCountries.map(F)), m = s(() => e.excludeCountries.map(F));
  Se(() => {
    const y = {}, V = [], L = [];
    e.allCountries.forEach((b) => {
      const u = F(b.iso2);
      if (n.indexOf(u) === -1 || o.value.length && o.value.indexOf(u) === -1 || m.value.indexOf(u) !== -1)
        return;
      const d = { ...b, iso2: u };
      y[d.iso2] = d, v.value.indexOf(u) !== -1 ? V.push(d) : L.push(d);
    }), V.sort((b, u) => v.value.indexOf(b.iso2) - v.value.indexOf(u.iso2)), t.value = y, i.value = V, p.value = L, r.value = V.length + L.length, r.value || console.error('[v-phone-input] resulting countries from "allCountries", "includeCountries" and "excludeCountries" must be a non-empty list');
  });
  const g = s(() => {
    const y = i.value[0] ?? p.value[0];
    return y ? t.value[y.iso2] : void 0;
  }), O = (y) => t.value[F(y)], h = f(!1), M = s(() => !e.disableGuessLoading && h.value);
  return {
    countriesCount: r,
    preferredCountries: i,
    otherCountries: p,
    guessingCountry: M,
    findCountry: O,
    firstCountry: g,
    setCountryPreference: (y) => {
      h.value = !1, Ne(e.countryGuesser) && e.countryGuesser.setPreference(y);
    },
    guessCountry: async () => {
      if (!e.guessCountry)
        return;
      h.value = !0;
      const y = O(await e.countryGuesser.guess());
      return h.value = !1, y == null ? void 0 : y.iso2;
    }
  };
}
function Ee({ props: e }) {
  return { countryIconComponent: s(() => {
    switch (e.countryIconMode) {
      case "svg":
        return je;
      case "sprite":
        return $e;
      case "text":
        return;
      default:
        return e.countryIconMode;
    }
  }) };
}
function Re({ props: e }) {
  return { countrySelectComponent: s(() => e.enableSearchingCountry ? {
    type: "VAutocomplete",
    props: {
      autocomplete: "new-password",
      "aria-autocomplete": "off"
    }
  } : {
    type: "VSelect",
    props: {}
  }) };
}
function Ue({ props: e, country: n, example: t }) {
  const r = (S, A) => typeof S == "function" ? S(A) : S, i = s(() => ({ country: n.value, example: t.value })), p = s(() => r(e.label, i.value)), v = s(() => r(e.ariaLabel, i.value)), o = s(() => ({
    ...i.value,
    label: p.value || v.value
  })), m = s(() => r(e.countryLabel, o.value)), g = s(
    () => r(e.countryAriaLabel, o.value)
  ), O = s(() => r(e.placeholder, o.value)), h = s(() => r(e.hint, o.value)), M = s(
    () => r(e.invalidMessage, o.value)
  );
  return {
    label: p,
    ariaLabel: v,
    countryLabel: m,
    countryAriaLabel: g,
    placeholder: O,
    hint: h,
    invalidMessage: M,
    messageOptions: i
  };
}
function De(e, n) {
  const t = f({}), r = () => {
    const i = {};
    Object.keys(e).forEach((p) => {
      const [v, ...o] = p.split(":");
      !o.length || n.indexOf(v) === -1 ? i.default = {
        ...i.default || {},
        [p]: p
      } : i[v] = {
        ...i[v] || {},
        [o.join(":")]: p
      };
    }), t.value = i;
  };
  return Ve(r), Le(r), { namespacedSlots: t };
}
const qe = Ae.map((e) => ({
  ...e,
  iso2: F(e.iso2)
})), oe = class ue {
  // eslint-disable-next-line class-methods-use-this
  async guess() {
    let n, t;
    try {
      n = await fetch(ue.IP2C_URL), t = await n.text();
    } catch {
      return;
    }
    const r = t.toString().split(";");
    if (!(!r || r[0] !== "1"))
      return r[1];
  }
};
oe.IP2C_URL = "https://ip2c.org/s";
let re = oe;
class He extends re {
  constructor() {
    super(...arguments), this.memoCountry = void 0;
  }
  async guess() {
    return this.memoCountry || (this.memoCountry = await super.guess()), this.memoCountry;
  }
  setPreference(n) {
    this.memoCountry = n;
  }
}
const We = {
  label: "Phone",
  ariaLabel: void 0,
  countryLabel: "Country",
  countryAriaLabel: (e) => `Country for ${e.label}`,
  placeholder: void 0,
  hint: void 0,
  invalidMessage: (e) => `The "${e.label}" field is not a valid phone number (example: ${e.example}).`,
  example: void 0,
  persistentPlaceholder: void 0,
  persistentHint: void 0,
  countryIconMode: void 0,
  allCountries: qe,
  preferCountries: [],
  includeCountries: [],
  excludeCountries: [],
  defaultCountry: void 0,
  countryGuesser: new He(),
  guessCountry: !1,
  disableGuessLoading: !1,
  enableSearchingCountry: !1,
  displayFormat: "national"
}, ae = { ...We };
function xe(e) {
  Object.assign(ae, e);
}
function c(e) {
  return ae[e];
}
function Je(e, n) {
  var t, r;
  return ((t = e.number) == null ? void 0 : t[n]) || ((r = e.number) == null ? void 0 : r.input) || "";
}
function Qe(e) {
  return ke(e);
}
function ee(e, n) {
  return _e((e || "").trim(), { regionCode: n });
}
const Xe = [
  "variant",
  "density",
  "singleLine",
  "hideDetails",
  "direction",
  "reverse",
  "color",
  "bgColor",
  "theme",
  "disabled",
  "readonly"
], Ye = U({
  components: {
    VListItem: Ge,
    VSelect: Be,
    VTextField: K
  },
  props: {
    label: {
      type: [String, Function],
      default: () => c("label")
    },
    ariaLabel: {
      type: [String, Function],
      default: () => c("ariaLabel")
    },
    countryLabel: {
      type: [String, Function],
      default: () => c("countryLabel")
    },
    countryAriaLabel: {
      type: [String, Function],
      default: () => c("countryAriaLabel")
    },
    placeholder: {
      type: [String, Function],
      default: () => c("placeholder")
    },
    hint: {
      type: [String, Function],
      default: () => c("hint")
    },
    invalidMessage: {
      type: [String, Function],
      default: () => c("invalidMessage")
    },
    example: {
      type: [String, Function],
      default: () => c("example")
    },
    appendIcon: {
      type: String,
      default: void 0
    },
    appendInnerIcon: {
      type: String,
      default: void 0
    },
    prependIcon: {
      type: String,
      default: void 0
    },
    prependInnerIcon: {
      type: String,
      default: void 0
    },
    rules: {
      type: Array,
      default: () => []
    },
    validateOn: {
      type: String,
      default: void 0
    },
    countryIconMode: {
      type: [String, Object],
      default: () => c("countryIconMode")
    },
    allCountries: {
      type: Array,
      default: () => c("allCountries")
    },
    preferCountries: {
      type: Array,
      default: () => c("preferCountries")
    },
    includeCountries: {
      type: Array,
      default: () => c("includeCountries")
    },
    excludeCountries: {
      type: Array,
      default: () => c("excludeCountries")
    },
    defaultCountry: {
      type: String,
      default: () => c("defaultCountry")
    },
    countryGuesser: {
      type: Object,
      default: () => c("countryGuesser")
    },
    guessCountry: {
      type: Boolean,
      default: () => c("guessCountry")
    },
    disableGuessLoading: {
      type: Boolean,
      default: () => c("disableGuessLoading")
    },
    enableSearchingCountry: {
      type: Boolean,
      default: () => c("enableSearchingCountry")
    },
    displayFormat: {
      type: String,
      default: () => c("displayFormat")
    },
    country: {
      type: String,
      default: ""
    },
    modelValue: {
      type: String,
      default: ""
    },
    countryProps: {
      type: Object,
      default: () => ({})
    },
    phoneProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: {
    "update:modelValue": (e) => !0,
    "update:country": (e) => !0
  },
  setup(e, { attrs: n, emit: t, slots: r }) {
    const {
      countriesCount: i,
      preferredCountries: p,
      otherCountries: v,
      guessingCountry: o,
      findCountry: m,
      firstCountry: g,
      setCountryPreference: O,
      guessCountry: h
    } = Te({ props: e }), M = f(null), S = f(null), { namespacedSlots: A } = De(r, ["country"]), { countryIconComponent: y } = Ee({ props: e }), { countrySelectComponent: V } = Re({ props: e }), L = f(!1), b = f([]), u = f(e.country), d = f(e.modelValue || ""), C = f({ number: { input: "" } }), le = s(() => ({
      ...V.value.props,
      ...Object.keys(n).reduce((a, l) => Xe.indexOf(l) !== -1 ? { ...a, [l]: n[l] } : a, {}),
      ...e.countryProps,
      menuProps: {
        maxHeight: 300,
        contentClass: "v-phone-input__country__menu",
        closeOnContentClick: !0,
        ...(e.countryProps ? e.countryProps.menuProps : void 0) || {}
      }
    })), se = s(() => ({
      ...n,
      ...e.phoneProps
    })), ie = s(() => m(e.defaultCountry) || g.value), k = s(() => m(u.value) || ie.value), ce = s(() => [...p.value.map((l) => ({ ...l, preferred: !0 })), ...v.value]), $ = (a) => Je(a, e.displayFormat), de = s(() => e.example !== void 0 ? typeof e.example == "function" ? e.example(k.value) : e.example : $(Qe(k.value.iso2))), ye = s(() => {
      var l;
      const a = new Set(((l = e.validateOn) == null ? void 0 : l.split("")) || []);
      return a.size === 0 || a.has("input");
    }), _ = Ue({ props: e, country: k, example: de }), D = () => {
      var a;
      ye.value && ((a = S.value) == null || a.validate());
    }, j = () => {
      const a = e.rules.map((l) => typeof l == "function" ? () => l(d.value ?? "", C.value, _.messageOptions.value) : l);
      _.invalidMessage.value ? b.value = [
        ...a,
        () => !d.value || C.value.valid || _.invalidMessage.value
      ] : b.value = a;
    }, pe = () => {
      C.value.valid && (d.value = $(C.value));
    }, ve = () => {
      var a, l;
      e.modelValue !== (((a = C.value.number) == null ? void 0 : a.input) ?? "") && e.modelValue !== (((l = C.value.number) == null ? void 0 : l.e164) ?? "") && (d.value = e.modelValue || "");
    }, fe = () => {
      e.country && e.country !== u.value && (u.value = e.country);
    };
    I(() => e.rules, j, { deep: !0, immediate: !0 }), I(() => e.displayFormat, pe), I(() => e.modelValue, ve), I(() => e.country, fe);
    const me = () => {
      j(), (d.value ?? "") !== "" && D();
    };
    I(_.invalidMessage, me);
    const Ce = () => {
      L.value = !0;
    }, ge = () => {
      L.value = !1;
    }, q = () => {
      C.value = ee(d.value, u.value), C.value.valid && (d.value = $(C.value));
    }, he = (a, l) => {
      u.value ? (t("update:country", u.value), O(u.value)) : x(() => {
        u.value || (u.value = l);
      }), q(), (d.value ?? "") !== "" && D();
    }, H = () => {
      if ((d.value || "").startsWith("+")) {
        const l = ee(d.value).regionCode;
        l && u.value !== l && m(l) && (u.value = l);
      }
      q();
    }, be = () => {
      var l, W;
      const a = ((l = C.value.number) == null ? void 0 : l.e164) || ((W = C.value.number) == null ? void 0 : W.input) || "";
      a !== e.modelValue && t("update:modelValue", a);
    };
    I(u, he), I(d, H), I(C, be, { deep: !0 });
    const Ie = async () => {
      if (u.value)
        return;
      if (i.value === 1) {
        u.value = g.value.iso2;
        return;
      }
      const a = await h();
      !u.value && a && (u.value = a), u.value = u.value || k.value.iso2;
    };
    return Pe(() => {
      H(), x(() => {
        Ie();
      });
    }), {
      VTextField: K,
      countryInput: M,
      phoneInput: S,
      namespacedSlots: A,
      countrySelectComponent: V,
      countryIconComponent: y,
      countryAttrs: le,
      phoneAttrs: se,
      countryFocused: L,
      guessingCountry: o,
      mergeRules: j,
      lazyCountry: u,
      lazyValue: d,
      mergedRules: b,
      activeCountry: k,
      labels: _,
      countriesItems: ce,
      onCountryFocus: Ce,
      onCountryBlur: ge
    };
  }
}), Ze = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [r, i] of n)
    t[r] = i;
  return t;
}, Ke = { key: 1 }, en = { class: "v-phone-input__country__title" }, nn = { class: "v-phone-input__country__append text-body-2" };
function tn(e, n, t, r, i, p) {
  const v = Oe("v-list-item");
  return w(), J("div", {
    class: we([{ "v-phone-input--prepend-inner-icon": e.prependInnerIcon }, "v-phone-input"])
  }, [
    (w(), G(B(e.countrySelectComponent.type), Q({
      ref: "countryInput",
      modelValue: e.lazyCountry,
      "onUpdate:modelValue": n[0] || (n[0] = (o) => e.lazyCountry = o),
      label: e.labels.countryLabel.value,
      "aria-label": e.labels.countryAriaLabel.value,
      items: e.countriesItems,
      "item-title": "name",
      "item-value": "iso2",
      loading: e.guessingCountry,
      "prepend-icon": e.prependIcon,
      "prepend-inner-icon": e.prependInnerIcon,
      class: [{ "v-phone-input--focused": e.countryFocused }, "v-phone-input__country__input"]
    }, e.countryAttrs, {
      onFocus: e.onCountryFocus,
      onBlur: e.onCountryBlur
    }), X({
      selection: P(() => [
        z(e.$slots, "country-icon", {
          country: e.activeCountry,
          decorative: !1
        }, () => [
          e.countryIconComponent ? (w(), G(B(e.countryIconComponent), {
            key: 0,
            country: e.activeCountry,
            decorative: !1
          }, null, 8, ["country"])) : (w(), J("span", Ke, N(`+${e.activeCountry.dialCode}`), 1))
        ])
      ]),
      item: P((o) => [
        ze(v, T(E(o.props)), {
          prepend: P(() => [
            z(e.$slots, "country-icon", {
              country: o.item.raw,
              decorative: !0
            }, () => [
              e.countryIconComponent ? (w(), G(B(e.countryIconComponent), {
                key: 0,
                country: o.item.raw,
                decorative: !0
              }, null, 8, ["country"])) : Fe("", !0)
            ])
          ]),
          title: P(() => [
            z(e.$slots, "country-title", {
              country: o.item.raw
            }, () => [
              Y("span", en, N(o.item.raw.name), 1)
            ])
          ]),
          append: P(() => [
            z(e.$slots, "country-append", {
              country: o.item.raw
            }, () => [
              Y("span", nn, " +" + N(o.item.raw.dialCode), 1)
            ])
          ]),
          _: 2
        }, 1040)
      ]),
      _: 2
    }, [
      Z(e.namespacedSlots.country, (o, m) => ({
        name: m,
        fn: P((g) => [
          z(e.$slots, o, T(E(g)))
        ])
      }))
    ]), 1040, ["modelValue", "label", "aria-label", "items", "loading", "prepend-icon", "prepend-inner-icon", "class", "onFocus", "onBlur"])),
    (w(), G(B(e.VTextField), Q({
      ref: "phoneInput",
      modelValue: e.lazyValue,
      "onUpdate:modelValue": n[1] || (n[1] = (o) => e.lazyValue = o),
      label: e.labels.label.value,
      "aria-label": e.labels.ariaLabel.value,
      placeholder: e.labels.placeholder.value,
      hint: e.labels.hint.value,
      rules: e.mergedRules,
      "append-icon": e.appendIcon,
      "append-inner-icon": e.appendInnerIcon,
      "validate-on": e.validateOn,
      class: "v-phone-input__phone__input",
      type: "tel"
    }, e.phoneAttrs), X({ _: 2 }, [
      Z(e.namespacedSlots.default, (o, m) => ({
        name: m,
        fn: P((g) => [
          z(e.$slots, m, T(E(g)))
        ])
      }))
    ]), 1040, ["modelValue", "label", "aria-label", "placeholder", "hint", "rules", "append-icon", "append-inner-icon", "validate-on"]))
  ], 2);
}
const on = /* @__PURE__ */ Ze(Ye, [["render", tn]]);
function sn(e) {
  return (n, t) => {
    t && console.warn("[v-phone-input] options must be passed as first argument of createVPhoneInput()"), xe(e || {}), n.component("VPhoneInput", on);
  };
}
class cn extends re {
  constructor(n = {}) {
    super(), this.storage = n.storage || localStorage, this.key = n.key || "v_phone_input_country";
  }
  async guess() {
    const n = this.retrieveStoredCountry();
    if (n)
      return n;
    const t = await super.guess();
    return t && this.saveStoredCountry(t), t;
  }
  setPreference(n) {
    this.saveStoredCountry(n);
  }
  retrieveStoredCountry() {
    return this.storage.getItem(this.key) || void 0;
  }
  saveStoredCountry(n) {
    this.storage.setItem(this.key, n);
  }
  getStorage() {
    return this.storage;
  }
  getKey() {
    return this.key;
  }
}
export {
  We as DEFAULT_OPTIONS,
  re as Ip2cCountryGuesser,
  He as MemoIp2cCountryGuesser,
  cn as StorageMemoIp2cCountryGuesser,
  $e as VCountryIconSprite,
  je as VCountryIconSvg,
  on as VPhoneInput,
  qe as countries,
  sn as createVPhoneInput,
  Je as formatPhone,
  c as getOption,
  Qe as makeExample,
  ee as makePhone,
  xe as mergeOptions
};
